.select-action-widget {
  border: 1px solid #ddd;
  border-radius: var(--fdt-core-borderradius-small) var(--fdt-core-borderradius-small) 0 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  width: 500px;
  max-height: 90vh;
}
.select-action-widget .select-action-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--fdt-semantic-color-background-accent-dark);
  color: var(--fdt-core-color-primary-50);
  width: 100%;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  border-radius: var(--fdt-core-borderradius-small) var(--fdt-core-borderradius-small) 0 0;
}
.select-action-widget .select-action-header .expand-toggle {
  background: none;
  border: none;
  font-weight: bold;
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 0.5rem;
}
.select-action-widget .select-action-header .expand-toggle .expand-icon {
  transition: transform 0.2s ease;
}
.select-action-widget .select-action-header .expand-toggle .expand-icon.rotated {
  transform: rotate(180deg);
}
.select-action-widget .select-action-header .action-buttons {
  display: flex;
  gap: 0.5rem;
}
.select-action-widget .select-action-header .custom-button {
  border: 1px solid var(--fdt-core-color-primary-50);
  border-radius: var(--fdt-core-borderradius-small);
  font-weight: normal;
  background: none;
}
.select-action-widget .select-action-header .custom-button:hover {
  background: var(--fdt-semantic-color-background-neutral-dark);
  color: var(--fdt-core-color-primary-50);
}
.select-action-widget .select-action-header .custom-button:active {
  background: var(--fdt-core-color-accent-500);
  color: var(--fdt-core-color-primary-50);
}
.select-action-widget .selected-system-list {
  list-style: none;
  margin: 0;
  padding: 0;
  background-color: white;
}
.select-action-widget .selected-system-list .selected-system-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-top: 1px solid #eee;
  width: 100%;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
}
.select-action-widget .selected-system-list .selected-system-item > div {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.select-action-widget .selected-system-list .selected-system-item .system-name {
  font-weight: bold;
}
.select-action-widget .selected-system-list .selected-system-item .system-description-name {
  color: #666;
  font-size: small;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  width: 100%;
}
.select-action-widget .selected-system-list .selected-system-item .remove-button {
  padding: 0.5rem 0.5rem 0 0.5rem;
  cursor: pointer;
}
.select-action-widget .expandable-wrapper {
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s;
}
.select-action-widget .expandable-wrapper.expanded {
  max-height: 1000px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */